import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'wynajem';

export default {

    getWynajem(){
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getWynajemId(id){
        return axios({
            method: 'get',
            url: URL + '/' + id,
        });
    },

    getWynajemData(dataOd, dataDo){
        return axios({
            method: 'get',
            url: URL + '/szukajWithResource/?dataOd=' + dataOd + '&dataDo=' + dataDo,
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/kalendarz/KalendarzService.js